import { useMemo } from "react";
import { withReact } from "slate-react";
import { createEditor } from "slate";
import { withHistory } from "slate-history";
import { withLinks } from "./links/withLinks";
import { withLists } from "./lists/withLists";
import { withImages } from "./images/withImages";
import { withHtml } from "./html/withHtml";
import { withTables } from "./tables/withTables";
import { withCorrectVoidBehavior } from "./withCorrectVoidBehavior";
const basePlugins = [
    withCorrectVoidBehavior,
    withLinks,
    withHtml,
    withReact,
    withHistory,
    withImages,
    withLists,
    withTables
];
export const useEditorWithPlugins = (plugins = []) => {
    const editor = useMemo(
    // .reverse places the leftmost basePlugin as the outer layer
    () => basePlugins
        .concat(plugins)
        .reverse()
        .reduce((editor, plugin) => plugin(editor), createEditor()), 
    // plugins never change, so never re-calculate
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return editor;
};
